import React, { useState } from "react";
import emailjs from "emailjs-com";
import { API_URL } from "../../api/APIUrl";

// Need to make a query here to get the user associated with the email address provided.
// I would need a separate token for password reset... this would expire every 30 min when used.
// Each Token will be associated with a user

const PasswordResetForm = () => {
  // create a token associated with the user here on form submit.

  const [visible, setVisible] = useState(false);
  const [email, setEmail] = useState("");
  const [token, setToken] = useState("");
  const [formState, setFormState] = useState({
    username: "",
  });
  let styleHidden = "d-none";
  if (visible) {
    styleHidden = "";
  } else {
    styleHidden = "d-none";
  }
  const handleChange = (event) => {
    const { name, value } = event.target;
    setFormState({
      ...formState,
      [name]: value,
    });
  };

  const createToken = async () => {
    const usernameCaps = formState.username.toUpperCase();

    // 1. Get User
    const userRes = await fetch(
      `${API_URL}/api/users/changepw/nologin/${usernameCaps}`
    );
    const userData = await userRes.json();

    // 2. Generate Token
    const tokenRes = await fetch(
      `${API_URL}/api/users/changePW/token/${userData._id}`,
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
      }
    );
    const tokenData = await tokenRes.json();

    // Update state for the UI/success message
    setEmail(userData.email);
    setToken(tokenData.token);

    // Return values to be used immediately in the form submit
    return { email: userData.email, token: tokenData.token };
  };
  const handleFormSubmit = async (event) => {
    event.preventDefault();

    // Get the fresh data directly from the function
    const { email, token } = await createToken();

    // Update hidden inputs manually if emailjs.sendForm needs them in the DOM
    document.getElementById("hidden-input-email").value = email;
    document.getElementById("hidden-input-code").value = token;
    document.getElementById("hidden-input-link").value =
      "https://mktcloud.megagenamerica.com/user-password-reset";

    await emailjs
      .sendForm(
        "service_7kfdjoi",
        "template_fsmf85a",
        event.target, // This now contains the updated hidden values
        "-4nqcbxCVpvbcRiqP"
      )
      .then((result) => console.log(result.text))
      .catch((error) => console.log(error.text));

    event.target.reset();
    setVisible(true);
  };
  return (
    <div className="login-form-box">
      <h3 className="mb-30">Reset Your Password</h3>
      <p className="mb-30">
        Please enter the username your account is associated with.
      </p>
      <form className="login-form" onSubmit={handleFormSubmit}>
        <input type="hidden" id="hidden-input-code" name="code" value=" " />
        <input type="hidden" id="hidden-input-link" name="link" value=" " />
        <input type="hidden" id="hidden-input-email" name="email" value=" " />
        <div className="input-box mb--30">
          <input
            type="text"
            placeholder="Username"
            name="username"
            id="username"
            required
            onChange={handleChange}
          />
        </div>
        <button className="rn-btn btn-default w-100 mb--30" type="submit">
          <span>Reset Password</span>
        </button>
        <p
          className={`results ${styleHidden}`}
          style={{ textAlign: "left" }}
          id="results"
        >
          An email has been sent to {email}. If this email is incorrect, please
          contact{" "}
          <a
            style={{ color: "blue" }}
            href="mailto:daniel.hong@megagenamerica.com"
          >
            daniel.hong@megagenamerica.com
          </a>
          <br />
        </p>
      </form>
    </div>
  );
};

export default PasswordResetForm;
